module.exports = __webpack_public_path__ + "static/media/ic_loan_schedule.27f6bb57.svg";